/*eslint-disable*/
import { useGet, usePut } from "./useRequest";
export function downloadDocument(candidateId, documentId) {
    const path = `/candidates/${candidateId}/agreement-documents/${documentId}`;
    return useGet(path);
}

export function updateDocumentStatus(data, documentId) {
  const path = `/updateapplicantdocumentstatus/${documentId}`;
  return usePut(path, data);
}

export function loadAgreementDocuments(candidateId, jobId, organisationId) {
  const path = `/applicantagreementdocument/${candidateId}/${jobId}/${organisationId}`;
  return useGet(path);
}

export function loadDocumentById(candidateId, jobId, documentid) {
  const path = `/GetCandidateDocumentSectionContent/${documentid}?candidateId=${candidateId}&jobId=${jobId}`;
  return useGet(path);
}

export function signDocumentSection(data, sectionid) {
  const path = `/SignCandidateDocumentSection/${sectionid}`;
  return usePut(path, data);
}
